import {APP} from './actionTypes';

export function closeErrorSnack() {
    return {
        type: APP.ERROR_SNACK_CLOSE
    };
}
